// extracted by mini-css-extract-plugin
export var avatar = "Auth-module--avatar--21de7";
export var centered = "Auth-module--centered--e127e";
export var email = "Auth-module--email--4c112";
export var lastSession = "Auth-module--lastSession--6ec12";
export var links = "Auth-module--links--92cd4";
export var signUpModal = "Auth-module--signUpModal--2594f";
export var supportLink = "Auth-module--supportLink--8db37";
export var verifyButton = "Auth-module--verifyButton--bb14b";
export var verifyButtonContainer = "Auth-module--verifyButtonContainer--f75f9";